import { Component, OnInit, ViewChild, ElementRef, Inject, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Validators } from '@angular/forms';

const nocUtil = require('../../../../../../noc/util/noc-util');

@Component({
  selector: 'app-sim-consumption-period-selector',
  template: require('./sim-consumption-period-selector.component.html'),
  styles: [require('./sim-consumption-period-selector.component.sass')],

})
export class SimConsumptionPeriodSelectorComponent implements OnInit {

  @ViewChild('simPeriodExportModal') simPeriodExportModal: ElementRef;
  @Output() select = new EventEmitter<{
    dateFrom: string,
    dateTo: string
  }>();

  simPeriodExportForm: FormGroup;
  simPeriodExportModalReference: NgbModalRef;
  maxDateTime = new Date();
  dateFormat = "yy/mm/dd";

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    @Inject("TimeZoneFactory") private timeZoneFactory: any
  ) {
    this.simPeriodExportForm = this.fb.group({
      dateFrom: ['', [Validators.required]],
      dateTo: ['', [Validators.required]]
    });
    
   }

  ngOnInit(): void {
  }

  async showModal() {
    this.simPeriodExportForm.patchValue({
        dateFrom: nocUtil.beginAndEndOfDate ( new Date () ).from,
        dateTo: nocUtil.beginAndEndOfDate ( new Date () ).to
    });
    this.simPeriodExportModalReference = await this.modalService.open(this.simPeriodExportModal, {
      backdrop: 'static'
    });
  }

  save = () => {
    if (this.simPeriodExportForm.valid) {
      this.select.emit({
        dateFrom: this.timeZoneFactory
            .dateInCurrentTimeZone(this.simPeriodExportForm.value.dateFrom)
            .format(),
        dateTo: this.timeZoneFactory
           .dateInCurrentTimeZone(this.simPeriodExportForm.value.dateTo)
           .format()
      });
      this.simPeriodExportModalReference.close();
   } else {

   }
  }
}
